import React from 'react'
import {FaBars} from 'react-icons/fa'
import { Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavItem, NavLinks } from './NavbarElements'

const Navbar = ({ toggle }) => {
  return (
    <>
        <Nav role="navigation" aria-label="Main navigation">
            <NavbarContainer>
                <NavLogo 
                    href="/#hero"
                    onClick={(e) => {
                        e.preventDefault();
                        const element = document.getElementById('hero');
                        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    aria-label="Minute Growth - Back to top"
                >
                    Minute Growth
                </NavLogo>
                <MobileIcon 
                    onClick={toggle}
                    aria-label="Toggle mobile menu"
                    role="button"
                    aria-expanded="false"
                >
                    <FaBars aria-hidden="true" />
                </MobileIcon>
                <NavMenu role="menubar">
                    <NavItem role="none">
                        <NavLinks 
                            href="/#work"
                            onClick={(e) => {
                                e.preventDefault();
                                const element = document.getElementById('work');
                                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }}
                            role="menuitem"
                            aria-label="View our work"
                        >
                            Our Work
                        </NavLinks>
                    </NavItem>
                    <NavItem role="none">
                        <NavLinks 
                            href="/#clients"
                            onClick={(e) => {
                                e.preventDefault();
                                const element = document.getElementById('clients');
                                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }}
                            role="menuitem"
                            aria-label="View our clients"
                        >
                            Our Clients
                        </NavLinks>
                    </NavItem>
                    <NavItem role="none">
                        <NavLinks 
                            href="/#about"
                            onClick={(e) => {
                                e.preventDefault();
                                const element = document.getElementById('about');
                                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }}
                            role="menuitem"
                            aria-label="Learn about us"
                        >
                            About Us
                        </NavLinks>
                    </NavItem>
                    <NavItem role="none">
                        <NavLinks 
                            href="/#contact"
                            onClick={(e) => {
                                e.preventDefault();
                                const element = document.getElementById('contact');
                                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }}
                            role="menuitem"
                            aria-label="Contact us"
                        >
                            Contact Us
                        </NavLinks>
                    </NavItem>
                </NavMenu>
            </NavbarContainer>
        </Nav>
    </>
  )
}

export default Navbar
